/// <amd-module name="TFS/Admin/Views/AdminRoles/Redux/AdminRolesReducers" />
import produce from "immer";

import { AdminRolesActions, AdminRolesActionTypes } from "TFS/Admin/Views/AdminRoles/Redux/AdminRolesActions";
import { IAdminRolesState } from "TFS/Admin/Views/AdminRoles/Contracts";

export function adminRolesReducer(state: IAdminRolesState, action: AdminRolesActions): IAdminRolesState {
    return produce(state || {}, draft => {
        switch (action.type) {
            case AdminRolesActionTypes.InitView: {
                draft.loading = true;
                break;
            }

            default:
                return state;
        }
    });
}
